var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 132,
    viewBox: "0 0 186 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2490_49861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.731 116.101C102.189 103.995 95.9229 90.3583 85.0102 90.0384C77.8703 89.8273 74.5988 105.931 66.4333 106.092C64.814 105.961 55.9823 103.718 53.2616 99.2131C50.9531 95.3875 52.7702 88.5774 48.6083 86.6251C41.4123 83.2481 33.8899 86.6482 27.9603 90.0417C18.4459 95.3974 10.7784 103.998 8.23902 116.105C6.92647 122.354 4.49924 126.849 17.2323 129.929C23.7852 131.516 40.0965 131.479 56.4374 131.483C56.4539 131.483 56.4671 131.483 56.4836 131.483C56.5001 131.483 56.5133 131.483 56.5298 131.483C72.8707 131.479 89.182 131.516 95.7349 129.929C108.471 126.846 106.044 122.351 104.731 116.101Z",
    fill: "#5441BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M104.731 116.101C102.189 103.995 95.9229 90.3583 85.0102 90.0384C77.8703 89.8273 75.1529 106.323 66.4333 106.092C64.814 105.961 55.9823 103.718 53.2616 99.2131C50.9531 95.3875 52.7702 88.5774 48.6083 86.6251C41.4123 83.2481 33.8899 86.6482 27.9603 90.0417C18.4459 95.3974 10.7784 103.998 8.23902 116.105C6.92647 122.354 4.49924 126.849 17.2323 129.929C23.7852 131.516 40.0965 131.479 56.4374 131.483C56.4539 131.483 56.4671 131.483 56.4836 131.483C56.5001 131.483 56.5133 131.483 56.5298 131.483C72.8707 131.479 89.182 131.516 95.7349 129.929C108.471 126.846 106.044 122.351 104.731 116.101Z",
    fill: "url(#paint0_linear_2490_49861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.029 82.9249C128.229 83.5812 58.9075 49.4086 57.9149 48.1455C56.9222 46.8825 59.2571 41.8169 60.7049 41.4772C62.1526 41.1376 101.872 62.0065 112.791 65.3736C123.711 68.7408 134.752 68.2131 136.978 70.9206C139.204 73.6315 133.825 82.2686 131.029 82.9249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8155 102.013L57.7368 99.1767C55.1578 97.7355 53.9013 94.7114 54.706 91.8686L69.9488 37.9088C70.9447 34.3867 74.6878 32.4212 78.1506 33.6018L95.3589 39.4687C99.0921 40.7417 100.787 45.0586 98.9206 48.5313L71.5482 99.4636C69.8597 102.603 65.9287 103.751 62.8155 102.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3215 108.945L90.2472 104.658L86.204 106.613L84.245 102.57L79.9578 104.645L81.9134 108.688L77.8702 110.647L79.9479 114.934L83.9911 112.978L85.9467 117.022L90.234 114.947L88.2783 110.901L92.3215 108.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1362 108.945L24.2139 104.658L28.2571 106.613L30.2127 102.57L34.5 104.645L32.5443 108.688L36.5875 110.647L34.5131 114.934L30.47 112.978L28.511 117.022L24.2238 114.947L26.1794 110.901L22.1362 108.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3487 120.382L52.0381 122.479C51.2763 119.462 52.5196 116.55 54.8149 115.969C57.1102 115.392 59.5869 117.368 60.3487 120.382Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4645 59.3575C92.4645 59.3575 106.511 23.89 153.392 23.89",
    stroke: "url(#paint1_linear_2490_49861)",
    strokeWidth: 39.5745
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2490_49861",
    x1: 56.4874,
    y1: 85.2279,
    x2: 56.4874,
    y2: 131.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00111041,
    stopColor: "#FF0030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0030",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2490_49861",
    x1: 85.7923,
    y1: 38.8142,
    x2: 143.91,
    y2: 40.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549179,
    stopColor: "white",
    stopOpacity: 0.345711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807063,
    stopColor: "white",
    stopOpacity: 0.135062
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2490_49861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 131.585,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoft);
export default __webpack_public_path__ + "static/media/soft.1b14d4c2a6566ce66d91d7041671c55b.svg";
export { ForwardRef as ReactComponent };